import HomePage from "pages/Home/Home";
import ResetPasswordWithTokenPage from "pages/Login/ResetPasswordWithTokenPage";
import SignUpPage from "pages/Signup/SignUp";
import { lazy } from "react";

import { appRoutesConst } from "./navigation";

// Components
const Dashboard = lazy(() => import("../pages/Dashboard/Dashboard"));
const VideoCallPage = lazy(() => import("../pages/VideoCall/VideoCallPage"));
const VideoCallPageWithLink = lazy(() =>
  import("containers/VideoCall/VideoCallPageWithLink")
);
const PatientInviteLinkPage = lazy(() =>
  import("../pages/VideoCall/PatientVideoCall/PatientInviteLinkPage")
);
const AppointmentsPage = lazy(() =>
  import("../pages/Appointments/AppointmentsPage")
);
const AddressBookPage = lazy(() =>
  import("../pages/AddressBook/AddressBookPage")
);
const GroupListingPage = lazy(() =>
  import("../pages/GroupListing/GroupListingPage")
);
const LoginPage = lazy(() => import("../pages/Login/LoginPage"));
const ForgotPasswordPage = lazy(() =>
  import("../pages/Login/ForgotPasswordPage")
);
const GuestVideoConsultationPage = lazy(() =>
  import("../pages/VideoCall/GuestVideoCallPage")
);

const PreCallTestPage = lazy(() =>
  import("../pages/VideoCallSetup/VideoCallSetupPage")
);

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    path: appRoutesConst.appointments,
    element: AppointmentsPage,
    isPrivateRoute: true,
  },
  {
    path: appRoutesConst.index,
    element: HomePage,
    isRestrictedRoute: true,
  },
  {
    path: appRoutesConst.signin,
    element: LoginPage,
    isRestrictedRoute: true,
  },
  {
    path: appRoutesConst.signup,
    element: SignUpPage,
    isRestrictedRoute: true,
  },
  {
    path: appRoutesConst.forgotpassword,
    element: ForgotPasswordPage,
    isRestrictedRoute: true,
  },
  {
    path: appRoutesConst.resetpasswordWithToken,
    element: ResetPasswordWithTokenPage,
    isRestrictedRoute: true,
  },
  {
    path: appRoutesConst.dashboard,
    element: Dashboard,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.videocall,
    element: VideoCallPage,
    isPrivateRoute: true,
  },
  {
    path: appRoutesConst.videofromemaillink,
    element: VideoCallPageWithLink,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.patientvideocall,
    element: PatientInviteLinkPage,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.patientvideocall,
    element: PatientInviteLinkPage,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.appointments,
    element: AppointmentsPage,
    isPrivateRoute: true,
  },
  {
    path: appRoutesConst.addressbook,
    element: AddressBookPage,
    isPrivateRoute: true,
  },
  {
    path: appRoutesConst.grouplisting,
    element: GroupListingPage,
    isPrivateRoute: true,
  },
  {
    path: appRoutesConst.guestvideoconsultation,
    element: GuestVideoConsultationPage,
    isOpenRoute: true,
  },
  {
    path: appRoutesConst.preCallTest,
    element: PreCallTestPage,
    isPrivateRoute: true,
  },
];
